import React from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

// react-markdown v10 already drops raw HTML and strips `javascript:` URLs via its default urlTransform. This wrapper layers on element allow-listing and forces safe link attrs. Default mode is for untrusted peer chat; `trusted` widens the allow-list for AI output (Claude emits structured h1/h2 in long responses; stripping them produces orphaned bold-paragraph soup).
const BASE = [
  'p', 'br', 'hr',
  'strong', 'em', 'del', 'code', 'pre',
  'ul', 'ol', 'li',
  'blockquote',
  'h3', 'h4', 'h5', 'h6',
  'a',
]
// h1 dropped in default — users type `#` meaning a hashtag, and `# WAKE UP` would visually dominate a channel. Tables trusted-only — gfm parses them regardless, so without these tags they render as soup; untrusted stays table-free to avoid screen-real-estate abuse.
const ALLOWED_UNTRUSTED = ['h2', ...BASE]
const ALLOWED_TRUSTED = ['h1', 'h2', 'table', 'thead', 'tbody', 'tr', 'th', 'td', ...BASE]

const components = {
  a: ({node, ...props}: any) => (
    <a {...props} target="_blank" rel="noopener noreferrer nofollow" />
  ),
}

// `rehypePlugins` run BEFORE the allow-list, so a caller can rewrite a tag rather than lose it to `unwrapDisallowed` — series-markdown.tsx re-bases every heading, which is what lets it run `trusted` (for the tables) without an h1 ever reaching this list. Chat passes none and is unaffected.
export default function SafeMarkdown({children, trusted, rehypePlugins}: {children: string, trusted?: boolean, rehypePlugins?: React.ComponentProps<typeof ReactMarkdown>['rehypePlugins']}) {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      rehypePlugins={rehypePlugins}
      allowedElements={trusted ? ALLOWED_TRUSTED : ALLOWED_UNTRUSTED}
      unwrapDisallowed
      components={components}
    >
      {children}
    </ReactMarkdown>
  )
}
